// extracted by mini-css-extract-plugin
module.exports = {"root":"PetAvatar_root__ymRbK","avatar":"PetAvatar_avatar__Ol60Z","dogs":"PetAvatar_dogs__-umXk","cats":"PetAvatar_cats__3mDrb","exotics":"PetAvatar_exotics__6ZvlN"};